module.exports = __webpack_public_path__ + "img/section28.63dabf87.png";